import { defineMessages } from 'react-intl';

export default defineMessages({
    useExistingLocation: {
        id: 'CPMIpolicycommon.directives.schedules.location.Use existing location?',
        defaultMessage: 'Use existing location?',
    },
    existingLocation: {
        id: 'CPMIpolicycommon.directives.schedules.location.Existing Location',
        defaultMessage: 'Existing Location',
    },
    newLocation: {
        id: 'CPMIpolicycommon.directives.schedules.location.New Location',
        defaultMessage: 'New Location',
    },
    isNonSpecificLocation: {
        id: 'CPMIpolicycommon.directives.schedules.Is Non Specific Location',
        defaultMessage: 'Is it a non-specific location?',
    }
});
